import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { get, isEmpty, isNil } from 'lodash';
import { translate } from 'containers/services/translate';
import { Listings } from 'containers/AppContainer/typings';
import victimIcon from 'images/victim-icon.svg';
import RegulationForm from 'containers/TransactionManagerTimeLine/OfferRegulation/RegulationForm';
import messages from 'containers/TransactionManagerTimeLine/OfferRegulation/messages';
import { Container } from 'containers/TransactionManagerTimeLine/VictimInfo/styles';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import {
  formatEmptyList,
  formatRecapRegulation,
  renderRegulationTransactionStep,
} from 'containers/TransactionManagerTimeLine/OfferRegulation/utils';
import { ButtonContainer } from 'containers/TransactionManagerTimeLine/OfferRegulation/styles';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import RegulationValidationDrawer from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationValidationDrawer';
import { TIMELINE_REGULATION_STATUS } from 'containers/data-structure';
import { getStatusByKey } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import { extractTimeLineIdByRegulationId } from 'containers/TransactionManagerTimeLine/utils';
import { TransactionType } from 'typings/globalTypes';

export interface RegulationCardProps {
  intl: IntlShape;
  inputLabelProps?: boolean;
  listings: Listings;
  isReadOnly: boolean;
  offerInfo: any;
  sagisClaim: any;
  victimInfo: any;
  responsabilitySharedRate: any;
  requestCreateCorporealRegulation: Function;
  regulations: any;
  requestGetRegulations: Function;
  requestSagisClaimInfo: Function;
  transactionInfo: TransactionType;
  requestGetRegulation: Function;
  requestValidateRegulation: Function;
  claimNumber: string;
  isConsultation: boolean;
  corpoRegulation: any;
  allCorpoRegulations: any;
}

const RegulationCard: React.FC<RegulationCardProps> = (props): JSX.Element => {
  const [regulationInfo, setRegulationInfo] = useState({} as any);
  const [isOpenValidationDrawer, setIsOpenValidationDrawer] = useState(
    false as any,
  );

  useEffect(() => {
    const transactionRegulation = formatRecapRegulation(
      get(props.victimInfo, 'victimKey'),
      [get(props.corpoRegulation, 'sagisRegulationId')],
      get(props.sagisClaim, 'regulations'),
      props.listings,
      get(props.victimInfo, 'beneficiaries', []),
    );
    if (!isEmpty(transactionRegulation)) {
      setRegulationInfo(transactionRegulation);
    }
  }, [
    props.victimInfo,
    props.sagisClaim,
    props.corpoRegulation,
    props.allCorpoRegulations,
    props.regulations,
    props.offerInfo,
  ]);

  const handleOpenValidationDrawer = () => {
    setIsOpenValidationDrawer(true);
  };

  const handleToggle = () => {
    setIsOpenValidationDrawer(!isOpenValidationDrawer);
  };
  const isRegulationPending =
    getStatusByKey(get(regulationInfo, 'paymentStatusCode')) ===
    TIMELINE_REGULATION_STATUS.PENDING;
  return (
    <Container className="container">
      <div className="victims">
        <div>
          <CustomAccordion
            title={translate(messages.regulationAccordionTitle, props)}
            textColor={COLORS.ACCORDION_TEXT_BLUE}
            bgColor={COLORS.ACCORDION_BG_BLUE}
            image={victimIcon}
          >
            <RegulationForm
              listings={props.listings}
              offerInfo={props.offerInfo}
              sagisClaim={props.sagisClaim}
              victimInfo={props.victimInfo}
              responsabilitySharedRate={props.responsabilitySharedRate}
              requestCreateCorporealRegulation={
                props.requestCreateCorporealRegulation
              }
              isReadOnly={
                !isEmpty(regulationInfo) &&
                !isNil(get(regulationInfo, 'paymentId', null))
              }
              regulationInfo={regulationInfo}
              setRegulationInfo={setRegulationInfo}
              requestSagisClaimInfo={props.requestSagisClaimInfo}
              requestGetRegulations={props.requestGetRegulations}
              transactionInfo={props.transactionInfo}
              corpoRegulation={props.corpoRegulation}
              corpoRegulations={formatEmptyList(props.allCorpoRegulations)}
            />
            {!isNil(get(regulationInfo, 'paymentId', null)) &&
              !props.isConsultation && (
                <ButtonContainer>
                  <PrimaryButton
                    background={BUTTON_COLORS.PRIMARY_BLUE}
                    border={BUTTON_COLORS.PRIMARY_BLUE}
                    titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                    title={translate(messages.validationTitle, props)}
                    onClick={handleOpenValidationDrawer}
                  />
                </ButtonContainer>
              )}
            <RegulationValidationDrawer
              open={isOpenValidationDrawer}
              requestValidateRegulation={props.requestValidateRegulation}
              requestGetRegulation={props.requestGetRegulation}
              regulationId={get(regulationInfo, 'paymentId')}
              corpoRegulationId={get(props.corpoRegulation, 'id')}
              claimNumber={props.claimNumber}
              claimId={get(props.victimInfo, 'claimId')}
              handleToggleDrawer={handleToggle}
              history={get(
                props.corpoRegulation,
                'regulationValidationHistory',
                [],
              )}
              regulationRejectionInfo={get(
                props.corpoRegulation,
                'regulationRejectionReason',
                {},
              )}
              isConsultation={props.isConsultation}
              isRegulationPending={isRegulationPending}
              listings={props.listings}
              transactionTimelineId={extractTimeLineIdByRegulationId(
                props.transactionInfo,
                renderRegulationTransactionStep(
                  get(props.corpoRegulation, 'regulationValidationHistory', []),
                ),
                get(props.corpoRegulation, 'id'),
              )}
              victimId={get(props.victimInfo, 'id')}
              transactionId={get(props.transactionInfo, 'id')}
            />
          </CustomAccordion>
        </div>
      </div>
    </Container>
  );
};
export default injectIntl(RegulationCard);
